import React from 'react';

const PopUpFeatureInfo = ({
                              featureData
                          }) => {

    return (
        <div className={'container'}>
            <div className={'row justify-content-center'}>
                <i className="fas fa-info-circle big-icon-colored"/>
            </div>
            <p className={'row justify-content-center global-text-center-bold'}>
                {
                    featureData
                    && featureData.properties
                    && featureData.properties.descr !== 'null' ?
                        featureData.properties.descr :
                        'Aucune information.'
                }
            </p>
        </div>
    );
};

export default PopUpFeatureInfo;